module.exports = __webpack_public_path__ + "media/educators/breeze-6b511707.gif";